import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthModalService } from './auth-modal.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authModalService: AuthModalService
  ) {}

  private isCompanyUser(): boolean {
    try {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const parsed = JSON.parse(userInfo);
        const role = parsed?.role;
        const roleName = typeof role === 'object' && role !== null
          ? role.name
          : role;
        return roleName?.toString().toUpperCase() === 'COMPANY';
      }
      // Fallback: check role from token info
      const role = localStorage.getItem('role');
      if (role) {
        return role.toString().toUpperCase().includes('COMPANY');
      }
    } catch {}
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      if (route.routeConfig?.path === 'login') {
        const redirectUrl = localStorage.getItem('redirectUrl');
        localStorage.removeItem('redirectUrl');
        if (redirectUrl && redirectUrl !== '/') {
          this.router.navigate([redirectUrl]);
        } else if (this.isCompanyUser()) {
          this.router.navigate(['/company-home']);
        } else {
          this.router.navigate(['/home']);
        }
        return false;
      }
      return true;
    } else {
      if (route.routeConfig?.path !== 'login') {
        this.authModalService.open(state.url);
        return false;
      }
      return true;
    }
  }
}